import { Box, Fade, Modal } from "@mui/material";
import React from "react";
import NewExtraRequestWithMessaging from "./NewExtraRequestWithMessaging";
import ExtraInfoBadge, { ExtraInfoDialog } from "./ExtraInfoDialog";
import ExtraRequestImage from "../../../assets/extraRequestProduct.png";
import CloseIcon from "../../../assets/crossPayment.png";
import { useSelector } from "react-redux";
import { authSelector } from "../../../../../redux/slices/authSlice";
import { Edit } from "@mui/icons-material";
import NewExtraRequestWithMessage from "../../../../admin/pages/products/components/NewExtraRequestWithMessage";
import { ReactComponent as AdditionalSVG } from "../../../../admin/assets/additional.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  height: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "30px 70px",
  outline: "none",
  borderRadius: "10px",
};

export default function NewRequotedProductDetailsModal({ product, requoteRequest }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { loggedUser } = useSelector(authSelector);

  const boxShadow = "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px";
  const isCustomer = loggedUser?.user?.role === "customer";
  return (
    <>
      {isCustomer ? (
        <>
          <ExtraInfoBadge product={product} onOpen={handleOpen} />
          <ExtraInfoDialog product={product} open={open} onClose={handleClose} />
        </>
      ) : product?.status === "accepted" &&
        product?.requote_request === "APPROVED" ? (
        <div
          style={{
            background: "white",
            padding: "7px 4px 2px 8px",
            borderRadius: "5px",
            marginLeft: "5px",
            marginRight: "6px",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
          }}
        >
          <Edit
            fontSize="small"
            style={{
              cursor: "pointer",
              marginRight: "5px",
              color: "#8D40FF",
            }}
            onClick={handleOpen}
          />
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            padding: "7px 8px 2px 10px",
            borderRadius: "5px",
            boxShadow: boxShadow,
            cursor: "pointer",
          }}
        >
          <AdditionalSVG width="20" height="20" onClick={handleOpen} />
        </div>
      )}
      {!isCustomer && (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <Box sx={{ ...style, maxWidth: "860px" }}>
            <div className="flexbox" style={{ padding: "0px 10px" }}>
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <div
                  style={{
                    padding: "10px 12px 5px 12px",
                    borderRadius: "5px",
                    marginRight: "20px",
                    marginTop: "5px",
                    boxShadow: boxShadow,
                  }}
                >
                  <img src={ExtraRequestImage} alt="productIcon" />
                </div>
                <div style={{ textAlign: "left" }}>
                  <h4 style={{ marginTop: 0, fontWeight: 600 }}>
                    Extra Request
                  </h4>
                  <h6 style={{ marginTop: 10 }}>
                    Request Additional Information about a product.
                  </h6>
                </div>
              </div>
              <img
                src={CloseIcon}
                alt="closeIcon"
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              />
            </div>
            {loggedUser?.user?.role === "customer" ? (
              <NewExtraRequestWithMessaging
                product={product}
                boxShadow={boxShadow}
                handleClose={handleClose}
              />
            ) : (
              <NewExtraRequestWithMessage
                product={product}
                boxShadow={boxShadow}
                handleClose={handleClose}
              />
            )}
          </Box>
        </Fade>
      </Modal>
      )}
    </>
  );
}
